import { makeFileApi } from 'src/http/api/internal/internal-http';
import { LoginRepository } from 'src/repositories/login/login.repository';
import { MeType } from 'src/types/me';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type States = {
  me: MeType | null;
};

type Actions = {
  getMyData: () => Promise<boolean>;
  setMe: (newMe: MeType | null) => void;
};

type LoginStore = States & Actions;

const repository = new LoginRepository(makeFileApi());

const initialState = {
  me: null,
};

export const useMyDataStore = create<LoginStore>()(
  persist(
    (set) => ({
      ...initialState,
      getMyData: async () => {
        const response = await repository.getData();
        if (response.isLeft()) {
          return false;
        }
        const { value } = response;
        set({ me: value as MeType });
        return true;
      },
      setMe: (me) => set({ me }),
    }),
    {
      name: 'my-data-store',
      partialize: (state) => ({ me: state.me }),
    }
  )
);
